<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Instant Service</font>
          &nbsp;&nbsp;&nbsp;
          <font class="h5 text-warning border bg-white rounded p-2">{{tanggal}}</font>
        </p>
      </b-col>
      <b-col md="6" class="mt-2" align="right">
        <b-button v-if="session.role == 'claim_manager' || session.role == 'superadmin'" class="bg-white text-primary border-secondary" @click="modalProductivityShow = !modalProductivityShow">Agent Productivity</b-button>
      </b-col>
    </b-row>
    <br />
    <b-row class="text-left">
      <b-col md="4">
        <b-card body-class="d-flex align-items-center">
          <div class="w-100">
            <b-row>
              <b-col md="6">
                <b-form-group
                  id="fieldset-handler"
                  label-class="control-label"
                  label="Handler:"
                  label-for="input-handler"
                  :class="'mb-0'"
                >
                  <p style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{session.role == 'claim' || session.role == 'claim_manager' ? session.fullname: '-'}}</p>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  id="fieldset-total-ticket"
                  label-class="control-label"
                  label="Total Tiket:"
                  label-for="input-total-ticket"
                  :class="'mb-0'"
                >
                  <b-spinner v-if="loadingSummary" label="Loading..."></b-spinner>
                  <p v-else style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{summary_claim.total_claim}}</p>
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col md="12">
                <b-form-group
                  id="fieldset-filter-date"
                  label-class="control-label"
                  label="Filter Tanggal:"
                  label-for="input-filter-date"
                >
                  <b-row>
                    <b-col md="6">
                      <b-row class="m-0">
                        <b-col
                          class="pr-0 pt-1 form-control img-calender-select border-right-0"
                          md="3"
                        >
                          <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                        </b-col>
                        <b-col class="px-0">
                          <datepicker
                            input-class="form-control text-dark pl-0 bg-white del-calender-select border-left-0 "
                            placeholder="From"
                            v-model="date_from"
                            :format="customFormatter"
                            @input="cxDate()"
                            :disabledDates="element2"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row class="m-0">
                        <b-col
                          class="pr-0 pt-1 form-control img-calender-select border-right-0"
                          md="3"
                        >
                          <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                        </b-col>
                        <b-col class="px-0">
                          <datepicker
                            input-class="form-control text-dark pl-0 bg-white del-calender-select border-left-0 "
                            placeholder="To"
                            v-model="date_to"
                            @input="cxDate()"
                            :format="customFormatter"
                            :disabledDates="element"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="border-left-warning h-100" body-class="d-flex align-items-center">
          <div class="card-with-border-left w-100">
            <b-form-group
              id="fieldset-claim-inbox"
              label-class="control-label text-warning"
              label="Klaim Masuk"
              label-for="input-claim-inbox"
              :class="'mb-0'"
            >
              <b-spinner v-if="loadingSummary" label="Loading..."></b-spinner>
              <p v-else style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{summary_claim.total_claim}}</p>
            </b-form-group>
            <hr />
            <b-form-group
              id="fieldset-claim-inbox"
              label-class="control-label text-warning"
              label="Total Nilai Klaim Masuk"
              label-for="input-claim-inbox"
              :class="'mb-0'"
            >
              <b-spinner v-if="loadingSummary" label="Loading..."></b-spinner>
              <p v-else style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{summary_claim.total_amount | rupiah}}</p>
            </b-form-group>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="border-left-primary h-100" body-class="d-flex align-items-center">
          <div class="card-with-border-left w-100">
            <b-form-group
              id="fieldset-claim-approved"
              label-class="control-label text-primary"
              label="Klaim Disetujui"
              label-for="input-claim-approved"
              :class="'mb-0'"
            >
              <b-spinner v-if="loadingSummary" label="Loading..."></b-spinner>
              <p v-else style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{refunded_claim.total_claim}}</p>
            </b-form-group>
            <hr />
            <b-form-group
              id="fieldset-claim-approved"
              label-class="control-label text-primary"
              label="Total Nilai Disetujui"
              label-for="input-claim-approved"
              :class="'mb-0'"
            >
              <b-spinner v-if="loadingSummary" label="Loading..."></b-spinner>
              <p v-else style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{refunded_claim.total_amount | rupiah}}</p>
            </b-form-group>
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="border-left-danger h-100" body-class="d-flex align-items-center">
          <div class="card-with-border-left w-100">
            <b-form-group
              id="fieldset-claim-rejected"
              label-class="control-label text-danger"
              label="Klaim Ditolak"
              label-for="input-claim-rejected"
              :class="'mb-0'"
            >
              <b-spinner v-if="loadingSummary" label="Loading..."></b-spinner>
              <p v-else style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{rejected_claim.total_claim}}</p>
            </b-form-group>
            <hr />
            <b-form-group
              id="fieldset-claim-rejected"
              label-class="control-label text-danger"
              label="Total Nilai Ditolak"
              label-for="input-claim-rejected"
              :class="'mb-0'"
            >
              <b-spinner v-if="loadingSummary" label="Loading..."></b-spinner>
              <p v-else style="font-weight: bold !important;margin-bottom: 0;word-break: break-all;">{{rejected_claim.total_amount | rupiah}}</p>
            </b-form-group>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex flex-wrap w-50">
              <b-button class="bg-white text-primary border-secondary mr-2" @click="modalFilterData = !modalFilterData">
                <span class="d-flex"><img src="@/assets/filter.svg" width="15px" alt />&nbsp;Filter Data</span>
              </b-button>
              <b-form-group class="mb-0 w-75">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="d-flex flex-wrap">
              <download-csv class="d-none" :data="CSV" name="tickets.csv" ref="DownloadCSV"></download-csv>
              <b-button class="btn btn-primary" :disabled="loadingCSV" @click="downloadCSV()">
                <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner><img src="@/assets/ic_export_csv.png" height="15px" alt class="mr-2" />Export to CSV
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="cxContent"
        hover
        selectable
        :select-mode="'single'"
        :items="getInfo"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :empty-filtered-text="empty_filtered_text"
        :empty-text="empty_text"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(time_issued)="row"><p style="font-weight: bold; color: #000000; word-break: break-word;">{{row.value | DateTimeV3}}</p></template>
        <template v-slot:cell(status)="row">
          <p class="text-warning" v-if="row.value == 'submitted'">Submitted</p>
          <p class="text-danger" v-else-if="row.value == 'rejected'">Rejected</p>
          <p class="text-info" v-else-if="row.value == 'on_review'">On Review</p>
          <p class="text-primary" v-else-if="row.value == 'refunded'">Refunded</p>
        </template>
        <template v-slot:cell(food_safe_guarantee)="row">
          <p v-if="row.value == true">Yes</p>
          <p v-else-if="row.value == false">No</p>
          <p v-else>-</p>
        </template>
        <template v-slot:cell(ticket_no)="{ item }">
          <router-link
            :to="{name: 'cxDetailInstantClaim', params: {id: item.id}}"
            class="text-primary text-decoration-none"
            v-b-tooltip.hover
            title="View Detail"
          >
            <p style="font-weight: bold; color: #000000">{{item.ticket_no}}</p>
          </router-link>
        </template>
        <template v-slot:cell(shipment_code)="{ item }">
          <router-link
            :to="{name: 'cxDetailInstantClaim', params: {id: item.id}}"
            class="text-decoration-none"
            v-b-tooltip.hover
            title="View Detail"
          >
            <p>{{item.shipment_code}}</p>
          </router-link>
        </template>
      </b-table>

      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-between">
            <b-col md="2">
              <b-form-group label-cols-sm="3" label="Show" class="mb-0">
                <b-form-select v-model="perPage" :options="pageOptions" class="col-md-6"></b-form-select>
              </b-form-group>
            </b-col>
            <div class="d-flex flex-wrap">
              <div class="align-self-center text-center p-2">Total entries {{totalRows}} | Page {{currentPage}} of {{totalRows > 0 ? Math.ceil(totalRows/perPage) : currentPage}}</div>
              <div>
                <b-pagination
                  align="right"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="modalProductivityShow"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h5 class="font-weight-bold mt-3">Agent Productivity</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              responsive
              striped
              show-empty
              ref="cxProductivity"
              hover
              :items="getInfoProductivity"
              :fields="fieldsProductivity"
              :current-page="currentPageProductivity"
              :per-page="perPageProductivity"
              head-variant="light"
              class="bg-white"
            >
              <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template v-slot:cell(average_handling_time)="{ item }">
                  <p class="mb-0">{{item.average_handling_time}} hrs</p>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="mx-auto">
          <b-col md="4" class="mx-auto"></b-col>
          <b-col md="4" align="right" class="px-0">
            <b-pagination
              align="right"
              v-model="currentPageProductivity"
              :total-rows="totalRowsProductivity"
              :per-page="perPageProductivity"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button
              variant="light"
              @click="modalProductivityShow = !modalProductivityShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="modalFilterData"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h5 class="font-weight-bold mt-3">Filter Data</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="fieldset-claim-status"
              label="Claim Status"
              class="font-weight-bold"
              label-for="input-claim-status"
            >
              <b-form-select
                v-model="claim_status_filtered"
                name="claim_status_filtered"
                class="mb-3"
              >
                <template v-slot:first>
                  <option value="">All</option>
                </template>
                <option value="submitted">Submitted</option>
                <option value="on_review">On Review</option>
                <option value="refunded">Refunded</option>
                <option value="rejected">Rejected</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="fieldset-claim-user"
              label="Claim User"
              class="font-weight-bold"
              label-for="input-claim-user"
            >
              <b-form-select
                v-model="claim_user_filtered"
                name="claim_user_filtered"
                class="mb-3"
              >
                <template v-slot:first>
                  <option value="">All</option>
                </template>
                <option
                  v-for="claim_user in claim_users"
                  :key="claim_user.id"
                  :value="claim_user.username"
                >
                  {{ claim_user.fullname }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row style="text-align-last: right">
          <b-col>
            <b-button
              variant="light"
              @click="cxResetFilterData()"
              class="text-primary border-secondary btn-secondary mr-3"
              size="lg"
              >Reset</b-button
            >
            <b-button variant="primary" size="lg" @click="cxFilterData()">Apply</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      modalShow: false,
      loading: true,
      loadingSummary: false,
      errored: false,
      modalProductivityShow: false,
      modalFilterData: false,
      // selected_field_true: true,
      // selected_field_false: false,
      items: [],
      // selectMode: "multi",
      // selected: [],
      // allSelected: false,
      indeterminate: false,
      fields: [
        {
          key: "time_issued",
          label: "Tanggal Pengajuan",
          sortable: true,
          class: "text-left",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-left",
        },
        {
          key: "ticket_no",
          label: "No Tiket",
          sortable: true,
          class: "text-left w-20",
        },
        {
          key: "shipment_code",
          label: "No Resi",
          sortable: true,
          class: "text-left",
        },
        {
          key: "food_safe_guarantee",
          label: "JMA",
          sortable: true,
          class: "text-left",
        },
        {
          key: "name",
          label: "Nama",
          class: "text-left",
        },
        {
          key: "aging_day",
          label: "Aging (Day)",
          class: "text-center",
        },
        {
          key: "aging_time",
          label: "Aging (Time)",
          class: "text-center",
        },
        {
          key: "sla_process_day",
          label: "SLA Process (Day)",
          class: "text-center",
        },
        {
          key: "sla_process_time",
          label: "SLA Process (Time)",
          class: "text-center",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      cx_type: "",
      cx_disbursement_type: "INSTANT_CLAIM",
      date_from: new Date(new Date().setDate(new Date().getDate() - 30)),
      date_to: new Date(Date.now()),
      loadingCSV: false,
      CSV: [],
      tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, "-"),
      routename: null,
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fieldsProductivity: [
        {
          key: "user",
          label: "Name",
          sortable: false,
          class: "text-left",
        },
        {
          key: "total_claim",
          label: "Total Ticket",
          sortable: false,
          class: "text-right",
        },
        {
          key: "average_handling_time",
          label: "Average HT",
          sortable: false,
          class: "text-right",
        }
      ],
      totalRowsProductivity: 1,
      currentPageProductivity: 1,
      perPageProductivity: 10,
      summary_claim: {
          total_claim: 0,
          total_amount: 0
      },
      refunded_claim: {
          total_claim: 0,
          total_amount: 0
      },
      rejected_claim: {
          total_claim: 0,
          total_amount: 0
      },
      session: this.$session.get("jwt"),
      claim_users: [],
      claim_user_filtered: "",
      claim_status_filtered: "",
      empty_text: "Tidak ada data yang ditampilkan",
      empty_text_default: "Tidak ada data yang ditampilkan",
      empty_filtered_text: "Mohon maaf data yang anda cari tidak ditemukan",
    };
  },
  watch: {
    element: {
      handler: function (newValue) {
        if (newValue) {
          this.element = newValue;
        }
      },
      deep: true,
    },
    element2: {
      handler: function (newValue) {
        if (newValue) {
          this.element2 = newValue;
        }
      },
      deep: true,
    },
    // selected(newVal, oldVal) {
    //   if (newVal.length === 0) {
    //     this.indeterminate = false;
    //     this.allSelected = false;
    //   } else if (newVal.length === this.items.length) {
    //     this.indeterminate = false;
    //     this.allSelected = true;
    //   } else {
    //     this.indeterminate = true;
    //     this.allSelected = false;
    //   }
    // }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    element() {
      var disabledDates = {
        to: new Date(this.date_from - 8640000),
      };
      return disabledDates;
    },
    element2() {
      var disabledDates = {
        from: new Date(this.date_to + 8640000),
      };
      return disabledDates;
    },
  },
  beforeCreate() {
    this.$store
      .dispatch("cxInstantClaim/getClaimUsers")
      .then((response) => {
        this.claim_users = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  created() {
    if (this.session.role == 'claim' || this.session.role == 'claim_manager') {
      this.getSummaryByUser();
    }
  },
  methods: {
    downloadCSV() {
      this.$swal({
        title: "Download CSV Report??",
        text: "Proses ini akan memakan waktu dan beban pada database",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.loadingCSV = true;
          const formData = new FormData();
          formData.append("search_param", "");
          formData.append("limit", "");
          formData.append("page", "");
          formData.append("sort_by", "created_time");
          formData.append("is_sort_asc", false);
          // formData.append("type", this.cx_type);
          formData.append("username", "");
          formData.append("status", "");
          formData.append("disbursement_type", this.cx_disbursement_type);
          formData.append(
            "date_from",
            this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
          );
          formData.append(
            "date_to",
            this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
          );
          this.$store
            .dispatch("cxInstantClaim/getCxCSV", formData)
            .then((response) => {
              this.CSV = response.data.data.results.tickets;
              setTimeout(() => {
                this.loadingCSV = false;
                this.$refs.DownloadCSV.$el.click();
              }, 1000);
            })
            .catch((error) => {
              this.loadingCSV = false;
              callback([]);
            });
        } else {
        }
      });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    cxFilterData() {
      this.modalFilterData = !this.modalFilterData;
      this.empty_text = this.empty_filtered_text;
      this.$refs.cxContent.refresh();
    },
    cxResetFilterData() {
      this.modalFilterData = !this.modalFilterData;
      this.claim_user_filtered = "";
      this.claim_status_filtered = "";
      this.empty_text = this.empty_text_default;
      this.$refs.cxContent.refresh();
    },
    cxDate() {
      if (this.date_to < this.date_from) {
        this.$swal({
          title: "Tanggal tidak sesuai!",
          type: "error",
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        this.$refs.cxContent.refresh();
        if (this.session.role == 'claim' || this.session.role == 'claim_manager') {
          this.getSummaryByUser();
        }
      }
    },
    resetFromdate() {
      this.date_from = "";
      this.$refs.cxContent.refresh();
    },
    resetTodate() {
      this.date_to = "";
      this.$refs.cxContent.refresh();
    },
    getSummaryByUser(){
      this.loadingSummary = true;
      const formData = new FormData();

      formData.append("username", this.session.username);
      formData.append("disbursement_type", this.cx_disbursement_type);
      formData.append(
        "date_from",
        this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "date_to",
        this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("cxInstantClaim/getCxSummaryByUser", formData)
        .then((response) => {
          this.loadingSummary = false;
          this.summary_claim = response.data.data.summary_claim;
          this.refunded_claim = response.data.data.refunded_claim;
          this.rejected_claim = response.data.data.rejected_claim;
        })
        .catch((error) => {
          this.loadingSummary = false;
        });
      return null;
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();

      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      // formData.append("type", this.cx_type);
      formData.append("username", this.claim_user_filtered);
      formData.append("status", this.claim_status_filtered);
      formData.append("disbursement_type", this.cx_disbursement_type);
      formData.append(
        "date_from",
        this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "date_to",
        this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("cxInstantClaim/getCxReports", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results.tickets || []);
          this.loading = false;
          this.items = response.data.data.results;
        })
        .catch((error) => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    getInfoProductivity(ctx, callback) {
      const vm = this;
      const formData = new FormData();

      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("disbursement_type", this.cx_disbursement_type);
      formData.append(
        "date_from",
        this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "date_to",
        this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("cxInstantClaim/getCxProductivity", formData)
        .then((response) => {
          vm.totalRowsProductivity = response.data.data.total_record;
          callback(response.data.data.results || []);
        })
        .catch((error) => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    date() {
      const currentDateWithFormat = "";
      this.tanggal = currentDateWithFormat;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // toggleAll(checked) {
    //   this.selected = checked
    //     ? this.$refs.cxContent.selectAllRows()
    //     : this.$refs.cxContent.clearSelected();
    // },
    // onRowSelected(items) {
    //   this.selected = items;
    // },
    // changeType() {
    //   this.$swal({
    //     title: "Are you sure?",
    //     text: `You will transfer this Auto Klaim to Customer Empathy!`,
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Yes, transfer it!"
    //   }).then(result => {
    //     if (result.value) {
    //       this.$swal({
    //         title: "Transfering...",
    //         text: "Please wait",
    //         imageUrl: "/img/loader_3_dots.gif",
    //         imageHeight: 100,
    //         showConfirmButton: false,
    //         allowOutsideClick: false
    //       });

    //       var selected = {ids: []};

    //       $.each(this.selected, (key, value) => {
    //         selected.ids.push(value.id);  
    //       });

    //       this.$store
    //         .dispatch("cxInstantClaim/putCxTransferToCE", selected)
    //         .then(response => {
    //           this.loading = false;
    //           this.$refs.cxContent.refresh();
    //           this.$swal({
    //             type: "success",
    //             title: "Transfer has been completed!",
    //             showConfirmButton: false,
    //             timer: 1000
    //           });
    //           console.log(response);
    //         })
    //         .catch(error => {
    //           this.loading = false;
    //           this.$swal(error.response.data.message);
    //           this.serverError = error.response;
    //           console.log(error);
    //         });
    //     }
    //   });

    //   // console.log(list);
    // },
    // toggleAll(checked) {
    //   this.selected = checked
    //     ? this.$refs.cxContent.selectAllRows()
    //     : this.$refs.cxContent.clearSelected();
    // }
  },
};
</script>

<style scoped>
.pointer-off {
  pointer-events: none;
}
.title {
  width: 120px;
}
</style>
